import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import 'rxjs/Rx';
import {AuthService} from './../../autenticacion/servicios/auth.service';
import {Router} from '@angular/router';
import {Ng2DeviceService} from 'ng2-device-detector';
import swal from 'sweetalert2';
import {UtilConfig} from '../servicios/UtilConfig';
import {ConsumerService} from '../../layout/recursos/servicio/consumer.service';
import {WebServices} from '../../layout/recursos/modelo/consumerModel/web-services.enum';

declare const $: any;

@Component({
    selector: 'app-verify-login-azure',
    templateUrl: './view/verifyAzureLogin.component.html',
    styleUrls: ['./css/verifyAzureLogin.component.scss'],
    providers: [AuthService]
})
export class VerifyAzureLoginComponent implements OnInit {
    loading = false;

    constructor(private jwtutil: UtilConfig,
                private deviceService: Ng2DeviceService,
                private consume: ConsumerService,
                private router: Router, fb: FormBuilder,
                private authService: AuthService) {


        this.jwtutil.removeSession();
        this.authService.logout();
    }

    ngOnInit() {

        $('.modal-backdrop.fade.in').remove();
        // http://patorjk.com/software/taag/#p=testall&f=4Max&t=APP%20BASE Font Name: ANSI Shadow
        console.log(`   
                     
    ███████╗███████╗ ██████╗ ██████╗ ███╗   ██╗    ██████╗  █████╗ ████████╗ █████╗  ██████╗  █████╗ ████████╗███████╗
    ██╔════╝██╔════╝██╔════╝██╔═══██╗████╗  ██║    ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗██╔════╝ ██╔══██╗╚══██╔══╝██╔════╝
    █████╗  ███████╗██║     ██║   ██║██╔██╗ ██║    ██║  ██║███████║   ██║   ███████║██║  ███╗███████║   ██║   █████╗  
    ██╔══╝  ╚════██║██║     ██║   ██║██║╚██╗██║    ██║  ██║██╔══██║   ██║   ██╔══██║██║   ██║██╔══██║   ██║   ██╔══╝  
    ███████╗███████║╚██████╗╚██████╔╝██║ ╚████║    ██████╔╝██║  ██║   ██║   ██║  ██║╚██████╔╝██║  ██║   ██║   ███████╗
    ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝
                                                                                                                  

                ___________________________________________________________________`);

        console.log('%c¡DETENTE!', ' font-weight: bold; color: red; font-size: 45px');
        console.log('%cEsta función del navegador esta pensada para desarrolladores.' +
            ' Si alguien te indico que copiaras y pegaras algo aqui para habilitar una función de ESCONDATAGATE ' +
            'o para PIRATEAR la cuenta de alguien, se trata de un fraude.', 'font-family: \';Arial\';, serif; color: gray; font-size: 20px');
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/verifyAzureLogin/verifyAzureLogin.component.ts